import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const IconLinkedIn = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <g clipPath="url(#clip0_linkedin)">
        <path
          d="M16.4703 0.180062H1.52944C1.36151 0.177662 1.19471 0.208487 1.03864 0.270587C0.882635 0.332762 0.74036 0.425012 0.61991 0.542087C0.499535 0.659237 0.403385 0.798887 0.33701 0.953162C0.27056 1.10744 0.235235 1.27334 0.23291 1.44126V16.5586C0.235235 16.7265 0.27056 16.8924 0.33701 17.0467C0.40346 17.2009 0.499535 17.3406 0.61991 17.4577C0.74036 17.5749 0.882635 17.6671 1.03864 17.7292C1.19471 17.7914 1.36151 17.8222 1.52944 17.8198H16.4703C16.6383 17.8222 16.8051 17.7914 16.9611 17.7292C17.1172 17.6671 17.2594 17.5749 17.3799 17.4577C17.5002 17.3406 17.5964 17.2009 17.6628 17.0467C17.7292 16.8924 17.7645 16.7265 17.7669 16.5586V1.44126C17.7645 1.27334 17.7292 1.10751 17.6628 0.953162C17.5964 0.798887 17.5002 0.659237 17.3799 0.542087C17.2594 0.425012 17.1172 0.332687 16.9611 0.270587C16.8051 0.208487 16.6383 0.177662 16.4703 0.180062ZM5.55131 14.9445H2.90531V7.00664H5.55131V14.9445ZM4.22831 5.89529C3.86344 5.89529 3.51349 5.75039 3.25541 5.49231C2.99741 5.23431 2.85244 4.88436 2.85244 4.51941C2.85244 4.15454 2.99741 3.80451 3.25541 3.54651C3.51349 3.28844 3.86344 3.14354 4.22831 3.14354C4.42211 3.12156 4.61831 3.14076 4.80416 3.19986C4.99001 3.25896 5.16124 3.35669 5.30666 3.48659C5.45216 3.61649 5.56849 3.77564 5.64821 3.95361C5.72786 4.13159 5.76911 4.32441 5.76911 4.51941C5.76911 4.71441 5.72786 4.90724 5.64821 5.08521C5.56849 5.26319 5.45216 5.42234 5.30666 5.55224C5.16124 5.68214 4.99001 5.77986 4.80416 5.83896C4.61831 5.89814 4.42211 5.91726 4.22831 5.89529ZM15.0944 14.9445H12.4485V10.6845C12.4485 9.61731 12.0692 8.92056 11.1078 8.92056C10.8103 8.92274 10.5206 9.01604 10.2777 9.18794C10.0349 9.35984 9.85054 9.60201 9.74959 9.88191C9.68051 10.0892 9.65059 10.3075 9.66139 10.5257V14.9357H7.01539V6.99779H9.66139V8.11791C9.90169 7.70084 10.2513 7.35719 10.6725 7.12409C11.0937 6.89099 11.5705 6.77721 12.0516 6.79491C13.8156 6.79491 15.0944 7.93266 15.0944 10.3758V14.9445Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_linkedin">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

IconLinkedIn.defaultProps = {
  className: null,
  rootClassName: null,
};

IconLinkedIn.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default IconLinkedIn;
